import { Alert, AlertDescription, AlertTitle } from "@veritrellis/ui";
import { Link } from "react-router-dom";
import { PLAN_FEATURE_MESSAGES } from "../../lib/apiErrors.js";

type PlanFeatureKey = "feature_approval_groups" | "feature_escalation_rules";

type PlanFeatureAlertProps = {
  feature: PlanFeatureKey;
  enabled: boolean;
  billingLoaded?: boolean;
};

export const PlanFeatureAlert = ({
  feature,
  enabled,
  billingLoaded = true
}: PlanFeatureAlertProps) => {
  if (!billingLoaded || enabled) {
    return null;
  }

  const copy = PLAN_FEATURE_MESSAGES[feature];

  return (
    <Alert className="border-amber-200 bg-amber-50">
      <AlertTitle>{copy.title}</AlertTitle>
      <AlertDescription>
        {copy.message}{" "}
        <Link to="/settings/billing" className="text-primary underline">
          Plan &amp; usage
        </Link>
      </AlertDescription>
    </Alert>
  );
};
